import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import TimePicker from '@components/TimePicker/TimePicker';
import Css from './FlightInfoRow.scss';
import theme from '@assets/scss/autosuggest-theme.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { Row, Col, InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Autosuggest from 'react-autosuggest';

import StringifyNumber from '@components/StringifyNumber/StringifyNumber';
import * as actions from '@store/actions';
import connect from 'react-redux/es/connect/connect';

const getSuggestionValue = suggestion => {
  return suggestion.typePhenom === 'Prohibited Airport'
    ? `${suggestion.city} (${suggestion.icaoCode}) (P300 Only)`
    : `${suggestion.city} (${suggestion.icaoCode})`;
};

const renderSuggestion = suggestion => {
  return (
    <div>
      {suggestion.city} ({suggestion.icaoCode})
      {suggestion.typePhenom === 'Prohibited Airport' && (
        <span>&nbsp;(P300 Only)</span>
      )}
    </div>
  );
};

class FlightInfoRow extends Component {
  constructor(props) {
    super(props);

    this.handleChange = props.dateChangeHandler.bind(this);
    this.handleTimeChange = props.timeChangeHandler.bind(this);

    this.suggestionTimeout = null;
    this.state = {
      from: '',
      to: ''
    };

    this.dateRef = React.createRef();
    this.timeRef = React.createRef();
  }

  onToggleAutosuggest = (key, value) => {
    const oldState = { ...this.state };
    oldState[key] = value;
    this.setState({ ...oldState });
  };

  getSuggestions = value => {
    clearTimeout(this.suggestionTimeout);
    this.suggestionTimeout = setTimeout(
      () => this.props.getAirportsList(value),
      500
    );
  };

  onSuggestionSelected = (suggestion, source) => {
    this.props.onAutosuggestAirportSelect(suggestion, this.props.id, source);
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = (value, from) => {
    this.setState({
      suggestionFrom: this.getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestionFrom: []
    });
  };

  onChange = (event, newValue, source) => {
    this.setState({
      from: newValue
    });
    this.props.inputChangeHandler(source, newValue);
  };

  render() {
    const ForceReadOnlyInput = React.forwardRef((props, ref) => (
      <input {...props} ref={ref} readOnly={true} />
    ));

    return (
      <div className={Css.container}>
        <div className={Css.header + ' lakes-medium font-sm'}>
          <StringifyNumber number={this.props.index} postfix={' leg'} />
          {this.props.index > 1 &&
            this.props.lastLeg && (
              <span
                className={'pointer float-right'}
                onClick={this.props.deleteHandler}
              >
                <FontAwesomeIcon icon={['fas', 'trash']} />
              </span>
            )}
        </div>
        <Row className={'pb-3'}>
          <Col>
            <InputGroup
              className={
                'input-group-icon ' +
                (this.props.from.visited && this.props.from.error !== false
                  ? 'is-invalid'
                  : '')
              }
            >
              {!this.props.isMobile && (
                <InputGroupAddon addonType="prepend" style={{ width: '60px' }}>
                  From
                </InputGroupAddon>
              )}
              {this.props.roundtrip ? (
                <Input value={this.props.from.value} disabled={true} />
              ) : (
                <Autosuggest
                  theme={theme}
                  suggestions={this.props.airports}
                  onSuggestionsFetchRequested={({ value }) =>
                    this.onSuggestionsFetchRequested(value, 'from')
                  }
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={getSuggestionValue}
                  renderSuggestion={renderSuggestion}
                  onSuggestionSelected={(event, { suggestion }) =>
                    this.onSuggestionSelected(suggestion, 'from', event)
                  }
                  shouldRenderSuggestions={value => {
                    return value !== undefined && value.trim().length > 1;
                  }}
                  inputProps={{
                    placeholder: this.props.isMobile ? 'From' : '',
                    className: 'form-control',
                    value: this.props.from.value,
                    onFocus: e => this.onToggleAutosuggest('focusFrom', true),
                    onBlur: e => this.onToggleAutosuggest('focusFrom', false),
                    onChange: (event, { newValue }) =>
                      this.onChange(event, newValue, 'from')
                  }}
                />
              )}
              <span
                className={'icon' + (this.props.roundtrip ? '' : ' pointer')}
                onClick={
                  this.props.roundtrip
                    ? null
                    : () =>
                        this.props.toggleAirportsModal(this.props.index, 'from')
                }
              >
                {this.props.loading && this.state.focusFrom ? (
                  <FontAwesomeIcon
                    className={'loading-ico'}
                    icon={['far', 'spinner']}
                    spin
                  />
                ) : (
                  <FontAwesomeIcon
                    className={'map-ico'}
                    icon={['fas', 'map-marker-alt']}
                  />
                )}
              </span>
            </InputGroup>
            {this.props.from.visited && (
              <span className={'error'} style={{ marginLeft: '59px' }}>
                {this.props.from.error}
              </span>
            )}
          </Col>
          <Col>
            <InputGroup
              className={
                'input-group-icon ' +
                (this.props.to.visited && this.props.to.error !== false
                  ? 'is-invalid'
                  : '')
              }
            >
              {!this.props.isMobile && (
                <InputGroupAddon addonType="prepend" style={{ width: '60px' }}>
                  To
                </InputGroupAddon>
              )}
              {this.props.roundtrip ? (
                <Input value={this.props.to.value} disabled={true} />
              ) : (
                <Autosuggest
                  theme={theme}
                  suggestions={this.props.airports}
                  onSuggestionsFetchRequested={({ value }) =>
                    this.onSuggestionsFetchRequested(value, 'to')
                  }
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={getSuggestionValue}
                  renderSuggestion={renderSuggestion}
                  onSuggestionSelected={(event, { suggestion }) =>
                    this.onSuggestionSelected(suggestion, 'to', event)
                  }
                  shouldRenderSuggestions={value => {
                    return value !== undefined && value.trim().length > 1;
                  }}
                  inputProps={{
                    placeholder: this.props.isMobile ? 'To' : '',
                    className: 'form-control',
                    value: this.props.to.value,
                    onFocus: e => this.onToggleAutosuggest('focusTo', true),
                    onBlur: e => this.onToggleAutosuggest('focusTo', false),
                    onChange: (event, { newValue }) =>
                      this.onChange(event, newValue, 'to')
                  }}
                />
              )}
              <span
                className={'icon' + (this.props.roundtrip ? '' : ' pointer')}
                onClick={
                  this.props.roundtrip
                    ? null
                    : () =>
                        this.props.toggleAirportsModal(this.props.index, 'to')
                }
              >
                {this.props.loading && this.state.focusTo ? (
                  <FontAwesomeIcon
                    className={'loading-ico'}
                    icon={['far', 'spinner']}
                    spin
                  />
                ) : (
                  <FontAwesomeIcon
                    className={'map-ico'}
                    icon={['fas', 'map-marker-alt']}
                  />
                )}
              </span>
            </InputGroup>
            {this.props.to.visited && (
              <span className={'error'} style={{ marginLeft: '59px' }}>
                {this.props.to.error}
              </span>
            )}
          </Col>
        </Row>

        <Row>
          <Col>
            <InputGroup
              className={
                'input-group-icon ' +
                (this.props.date.visited && this.props.date.error !== false
                  ? 'is-invalid'
                  : '')
              }
            >
              {!this.props.isMobile && (
                <InputGroupAddon addonType="prepend" style={{ width: '60px' }}>
                  Date
                </InputGroupAddon>
              )}

              <DatePicker
                placeholderText={this.props.isMobile ? 'Date' : ''}
                className={'form-control'}
                onChange={this.handleChange}
                selected={this.props.date.value}
                customInput={<ForceReadOnlyInput />}
                ref={this.dateRef}
                minDate={this.props.previousDate}
                todayButton="Today"
                popperPlacement={'bottom-end'}
              />
              <span
                className={'icon pointer'}
                onClick={() => {
                  this.dateRef.current.setFocus();
                }}
              >
                <FontAwesomeIcon icon={['fas', 'calendar-alt']} />
              </span>
            </InputGroup>
            {this.props.date.visited && (
              <span className={'error'} style={{ marginLeft: '59px' }}>
                {this.props.date.error}
              </span>
            )}
          </Col>
          <Col>
            <InputGroup
              className={
                'input-group-icon ' +
                (this.props.time.visited && this.props.time.error !== false
                  ? 'is-invalid'
                  : '')
              }
            >
              {!this.props.isMobile && (
                <InputGroupAddon addonType="prepend" style={{ width: '60px' }}>
                  Time
                </InputGroupAddon>
              )}
              <div className={'react-datepicker-wrapper background-fullwhite'}>
                <TimePicker
                  isMobile={this.props.isMobile}
                  placeholder={this.props.isMobile ? 'Time' : ''}
                  value={this.props.time.value}
                  onChange={value => this.handleTimeChange(value)}
                  className={
                    'form-control background-transparent position-relative no-background'
                  }
                  style={{ zIndex: 2 }}
                  reference={this.timeRef}
                />

                <span
                  className={'icon pointer'}
                  onClick={() => {
                    console.log(this.timeRef);
                    console.log(this.timeRef.current);
                    this.timeRef.current.select.focus();
                  }}
                >
                  <FontAwesomeIcon icon={['fas', 'clock']} />
                </span>
              </div>
            </InputGroup>
            {this.props.time.visited && (
              <span className={'error'} style={{ marginLeft: '59px' }}>
                {this.props.time.error}
              </span>
            )}
          </Col>
        </Row>

        {this.props.index > 1 && (
          <Row>
            <Col
              className={
                'font-sm pt-2 ' + (this.props.isMobile ? 'text-left' : '')
              }
            >
              <input
                type={'checkbox'}
                className={'mr-2'}
                checked={this.props.roundtrip}
                onChange={this.props.onRoundtripChange}
              />
              Make this a round trip
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    airports: state.airports.airports,
    loading: state.airports.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAirportsList: phraze => dispatch(actions.airportsAutosuggestList(phraze))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlightInfoRow);



// WEBPACK FOOTER //
// ./src/components/Quoting/Board/FlightInfo/FlightInfoRow/FlightInfoRow.jsx